import React, { FC } from 'react';
import BaseTemplate from '../BaseTemplate';
import { Button } from '../../atoms';
import cn from 'classnames';
import styles from './LandscapeAboutParticipantsTemplate.module.css';
import { useNavigate, useParams } from 'react-router-dom';
import LandscapeBaseEditTemplate from '../../../templates/LandscapeBaseEditTemplate';
import { Container } from 'react-bootstrap';
import { ParticipantResponseDto } from '../../../store/landscapeAPI/participant/dto/response/participant-response.dto';
import LandscapeAboutBaseEditTemplate from '../../../templates/LandscapeAboutBaseEditTemplate';
import { LandscapeAboutParticipantsOrganism } from '../../organisms';

interface LandscapeAboutParticipantsTemplateProps {
  participants: ParticipantResponseDto[];
  handleEdit: (id: string) => void;
  handleDelete: (id: string) => void;
}

const LandscapeAboutParticipantsTemplate: FC<
  LandscapeAboutParticipantsTemplateProps
> = ({ participants, handleEdit, handleDelete }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  return (
    <BaseTemplate>
      <Container>
        <LandscapeBaseEditTemplate>
          <LandscapeAboutBaseEditTemplate>
            <div className={cn(styles.landscapeAboutParticipantsWrapper)}>
              <div className={cn(styles.button)}>
                <Button
                  variant="dark"
                  onClick={() =>
                    navigate(`/landscapes/edit/${id}/about/participant/add`)
                  }
                >
                  Add Participant
                </Button>
              </div>
              <div className={cn(styles.tableWrapper)}>
                <LandscapeAboutParticipantsOrganism
                  participants={participants}
                  handleEdit={handleEdit}
                  handleDelete={handleDelete}
                />
              </div>
            </div>
          </LandscapeAboutBaseEditTemplate>
        </LandscapeBaseEditTemplate>
      </Container>
    </BaseTemplate>
  );
};

export default LandscapeAboutParticipantsTemplate;
